/* eslint-disable import/prefer-default-export */
export const SseEvents = {
  CONTROLLER_UPDATE: 1,
  WATERING_UPDATE: 2,
};
